import { Controller } from '@hotwired/stimulus'
import IMask, { MaskedRange } from 'imask'
import { dateFormat } from 'locale'
import { dateToText, textToDate } from '../../lib/i18n'

export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, this.imaskOptions)
  }

  disconnect() {
    this.mask?.destroy()
  }

  get imaskOptions() {
    return {
      mask: Date,
      pattern: dateFormat,
      lazy: true,
      format: dateToText,
      parse: textToDate,
      blocks: {
        dd: { mask: MaskedRange, from: 1, to: 31 },
        MM: { mask: MaskedRange, from: 1, to: 12 },
        yyyy: { mask: MaskedRange, from: 1900, to: 3000 },
      },
    }
  }
}
